import { usePostMutation, usePutMutation } from "slices/api";

export const useRequestOTPMutation = () => {
  const [handleForgotPassword, data] = usePostMutation();
  const forgotPassword = async (
    query = {},
    toastMessage,
    isFireSafety = false
  ) => {
    return await handleForgotPassword({
      endpoint: isFireSafety
        ? "/firesafety-user/request-otp"
        : "/user/request-otp",
      query,
      toastMessage,
      tags: [],
    }).unwrap();
  };
  return [forgotPassword, data];
};

export const useValidateOTPPutMutation = () => {
  const [validateOTP, data] = usePutMutation();
  const handleOTP = async (payload, query = {}, isFireSafety = false) => {
    return await validateOTP({
      endpoint: isFireSafety
        ? "/firesafety-user/validate-otp"
        : "/user/validate-otp",
      query,
      payload: payload || {},
      toastMessage: "OTP verified successfully",
      tags: [],
    }).unwrap();
  };
  return [handleOTP, data];
};

export const useSetNewPasswordPutMutation = () => {
  const [handlePassword, data] = usePutMutation();
  const setNewPassword = async (payload, query = {}, isFireSafety = false) => {
    return await handlePassword({
      endpoint: isFireSafety
        ? "/firesafety-user/set-new-password"
        : "/user/set-new-password",
      query,
      payload: payload || {},
      toastMessage: "Password changed successfully",
      tags: [],
    }).unwrap();
  };
  return [setNewPassword, data];
};
